export default "/images/vendor/flag-icon-css/flags/4x3/ht.svg?3af38bff509f443ef70e799f51a0e5c0";